import React, { useState, useContext } from 'react'
import Spinner from '../spinner/spinner'
import BugsnagContext from '../../context/bugsnag-context'
import AuthContext from '../auth/auth-context'
import DashboardContext from '../layout/dashboard-context'
import { useNavigate } from 'react-router-dom'
import InputFormikField from '../forms/input-formik-field'
import { Formik, Form, FormikValues } from 'formik'
import * as Yup from 'yup'
import api from '../../api'

interface ISalaryData {
  setCurrentYearReported: (currentYearReported: boolean) => void
  setSuccess: (success: boolean) => void
}

const PayDataFrom: React.FC = ({setSuccess, setCurrentYearReported }: ISalaryData) => {
  const [loading, setLoading] = useState(false)
  const [thisYearsData, setThisYearsData] = useState({
    salaryAmountTfl: 0,
    salaryAmountPainters: 0,
    totalAmount: 0,
    salaryAmountTrf: 0,
    year: new Date().getFullYear() - 1,
    id: '',
  })
  const [sendReport, setSendReport] = useState(false)
  const { bugsnagClient } = useContext(BugsnagContext)
  const { token } = useContext(AuthContext)
  const { selectedOrganization } = useContext(DashboardContext)
  const navigate = useNavigate()

  bugsnagClient.metaData = {
    token,
    page: 'pay-data',
  }

  const postNewData = async (values: FormikValues) => {
    setThisYearsData({
      salaryAmountTfl: values.salaryAmountTfl,
      salaryAmountPainters: values.salaryAmountPainters,
      totalAmount: values.totalAmount,
      salaryAmountTrf: values.salaryAmountTrf,
      year: values.year,
      id: '',
    })

    if (sendReport) {
      setLoading(true)

      try {
        await createPayData()
      } catch (e) {
        bugsnagClient.notify(e)
      }
      setCurrentYearReported(true)
      setLoading(false)
      setSuccess(true)
      setSendReport(false)
    } else {
      if (
        thisYearsData.totalAmount ||
        (thisYearsData.totalAmount === 0 &&
          thisYearsData.salaryAmountTfl === 0 &&
          thisYearsData.salaryAmountPainters === 0 &&
          thisYearsData.totalAmount === 0)
      ) {
        setSendReport(true)
      }
    }
  }

  const createPayData = async () => {
    try {
      const res = await api.post(`/accounts/${selectedOrganization.id}/salaries`, thisYearsData)

      return res.data
    } catch (e) {
      bugsnagClient.notify(e)

      return []
    }
  }

  return (
    <div className="flex flex-col justify-between md:flex-row">
      <div className="w-full">
        <div className="w-full">
          <Formik
            enableReinitialize
            initialValues={thisYearsData}
            validationSchema={validationSchema}
            onSubmit={postNewData}
          >
            {({ errors, touched }) => {
              return (
                <Form translate="" className="w-full">
                  <div className="flex flex-row gap-4">
                    <InputFormikField
                      name="year"
                      label="År"
                      placeholder="År"
                      type="number"
                      errors={errors}
                      touched={touched}
                    />
                    <InputFormikField
                      name="salaryAmountTfl"
                      label="Lönesumma TFL"
                      placeholder="Lönesumma TFL"
                      type="number"
                      errors={errors}
                      touched={touched}
                      toolTipTitle="Lönesumma TFL"
                      toolTipMessage="Avser de kollektivanställdas lönesumma, exklusive VD."
                    />
                    <InputFormikField
                      name="salaryAmountTrf"
                      label="Lönesumma TRF"
                      placeholder="Lönesumma TRF"
                      type="number"
                      errors={errors}
                      touched={touched}
                      toolTipTitle="Lönesumma TRF"
                      toolTipMessage="Avser tjänstemännens lönesumma, exklusive VD."
                    />
                    <InputFormikField
                      name="salaryAmountPainters"
                      label="Lönesumma målare"
                      placeholder="Lönesumma målare"
                      type="number"
                      errors={errors}
                      touched={touched}
                      toolTipTitle="Lönesumma målare"
                      toolTipMessage="Avser personal på månadslöneavtalet, ej ackordsavtalet."
                    />
                    <InputFormikField
                      name="totalAmount"
                      label="Total lönesumma"
                      placeholder="Total lönesumma"
                      type="number"
                      errors={errors}
                      touched={touched}
                      toolTipTitle="Total lönesumma"
                      toolTipMessage="Samtliga anställa inom bolaget inklusive VD."
                    />
                  </div>

                  <div className="justify-start flex flex-row py-2 mt-8">
                    {loading ? (
                      <Spinner />
                    ) : (
                      <div className="self-end flex flex-row gap-8 py-2 just justify-between w-full">
                        <button className="btn-white w-full" onClick={() => navigate('/')}>
                          Avbryt
                        </button>
                        <button className="btn w-full">Lämna in årslönesummor</button>
                      </div>
                    )}
                  </div>
                </Form>
              )
            }}
          </Formik>
        </div>
      </div>
    </div>
  )
}

const validationSchema = Yup.object().shape({
  salaryAmountTfl: Yup.number().required(
    'Fältet är obligatoriskt, ange 0 om inga löner betalats ut',
  ),
  salaryAmountPainters: Yup.number().required(
    'Fältet är obligatoriskt, ange 0 om inga löner betalats ut',
  ),
  salaryAmountTrf: Yup.number().required(
    'Fältet är obligatoriskt, ange 0 om inga löner betalats ut',
  ),
  totalAmount: Yup.number().required('Fältet är obligatoriskt, ange 0 om inga löner betalats ut'),
  year: Yup.number().required('Fältet är obligatoriskt'),
})

export default PayDataFrom
